'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Input from '../Input/index.js';
import { EPages, LOGIN_POPUP, UPDATE_USER, USER_NOT_ACTIVE_EN, USER_NOT_ACTIVE_VI, USER_EMPLOYER_EN, USER_EMPLOYER_VI, USER_BANNED_EN, USER_BANNED_VI, WS_TOKEN, JS_TOKEN, JS_ALL_TOKEN, USER_COOKIE, WS_COOKIE, VNW_CSRF_JWT_TOKEN, KEY_AUTH_TOKEN } from './constants.js';
import { RegisterLink, LoginModalContainerWrapper, SocialLoginGroup, SmallLabel, InputGroup, LabelInput, ErrorMessage, ForgotGroup, ForgotPasswordLink } from './LoginModal.css.js';
import { ELanguage } from '../Utils/constants.js';
import translations from './translations.js';
import { setCookie } from '../Utils/cookie.js';
import Button from '../Button/index.js';
import GoogleLogoIcon from '../Images/GoogleLogoIcon/index.js';
import FacebookLogoIcon from '../Images/FacebookLogoIcon/index.js';
import { getRegisterUrl, isMobile, getForgotPasswordUrl, getSocialLoginUrl, getBaseMsUrl, getBaseUrl } from './helper.js';
import { apiGetUserInfoFromToken, apiDoLogin, apiGetCSRFToken, apiVerifyAuthToken } from './services.js';
import { checkIfEmailInString } from '../Utils/helpers.js';
import Popup from '../Popup/index.js';
import { DEFAULT_SUCCESS_CODE } from '../QuickApplyJobModal/type.js';
import LoadingIcon from '../Images/LoadingIcon/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import { sendHogIdentify } from '../PostHog/hooks/useIdentify/index.js';
import { delay } from '../PostHog/utils.js';

var LoginModal = function (props) {
    var langCode = props.langCode, _a = props.isReloadOnLoggedIn, isReloadOnLoggedIn = _a === void 0 ? false : _a, _b = props.pageName, pageName = _b === void 0 ? EPages.OTHER : _b, _c = props.utmTracking, utmTracking = _c === void 0 ? '' : _c;
    var _d = useState(langCode === ELanguage.VI ? 'vi' : 'en'), modalLangCode = _d[0], setLangCode = _d[1];
    var _e = useState(false), isMounted = _e[0], setMounted = _e[1];
    // Forms
    var _f = useState(''), username = _f[0], setUsername = _f[1];
    var _g = useState(''), password = _g[0], setPassword = _g[1];
    var _h = useState(''), csrfToken = _h[0], setCsrfToken = _h[1];
    var _j = useState(''), jwtToken = _j[0], setJwtToken = _j[1];
    // Errors
    var _k = useState(false), isUsernameError = _k[0], setUsernameError = _k[1];
    var _l = useState(false), isPasswordError = _l[0], setPasswordError = _l[1];
    var _m = useState('NONE'), apiError = _m[0], setAPIError = _m[1];
    // End Forms
    var _o = useState(false), isLoginDisabled = _o[0], setIsLoginDisabled = _o[1];
    var _p = useState(false), isLoggingIn = _p[0], setIsLoggingIn = _p[1];
    // Other
    var _q = useState(isReloadOnLoggedIn), isNeedReload = _q[0], setIsNeedReload = _q[1];
    var _r = useState(false), isApply = _r[0], setIsApply = _r[1];
    var _s = useState(''), socialUtm = _s[0], setSocialUtm = _s[1];
    var _t = useState(false), isRegisterOnNewTab = _t[0], setRegisterOnNewTab = _t[1];
    // Callback on success
    var onLoggedInRef = useRef(null);
    // Callback on close popup login
    var onCancelPopupRef = useRef(null);
    var tracking = useHog().tracking;
    var t = function (text) {
        var _a;
        if (modalLangCode === ELanguage.EN) {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var showLoginModal = function (e, isNeedReload) {
        var _a, _b, _c, _d, _e;
        if (isNeedReload === void 0) { isNeedReload = false; }
        // window function
        if (typeof e === 'string') {
            setLangCode(e);
            setIsNeedReload(isNeedReload);
        }
        // window event
        if (typeof e === 'object') {
            var eventDetail = e.detail;
            setLangCode((_a = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.langCode) !== null && _a !== void 0 ? _a : 'vi');
            setIsNeedReload((_b = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNeedReload) !== null && _b !== void 0 ? _b : false);
            setIsApply((_c = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isApply) !== null && _c !== void 0 ? _c : false);
            setSocialUtm((_d = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.utm) !== null && _d !== void 0 ? _d : '');
            setRegisterOnNewTab((_e = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.isNewTabOnRegister) !== null && _e !== void 0 ? _e : false);
            onLoggedInRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onLoggedIn;
            onCancelPopupRef.current = eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.onCancelPopup;
        }
        setMounted(true);
    };
    var doLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var hasError, response, letCheckReload, jsToken, wsToken, userInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoginDisabled(true);
                    setIsLoggingIn(true);
                    hasError = false;
                    // username
                    if (username.length === 0) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // email not valid
                    if (!checkIfEmailInString(username)) {
                        setUsernameError(true);
                        hasError = true;
                    }
                    // password
                    if (password.length === 0) {
                        setPasswordError(true);
                        hasError = true;
                    }
                    if (hasError) {
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiDoLogin({
                            username: username,
                            password: password,
                            csrfToken: csrfToken,
                            jwtToken: jwtToken,
                            langCode: modalLangCode
                        })];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== DEFAULT_SUCCESS_CODE) {
                        // show login error
                        // waiting backend response correct error message for user not active
                        if ((response === null || response === void 0 ? void 0 : response.message) === USER_NOT_ACTIVE_EN || (response === null || response === void 0 ? void 0 : response.message) === USER_NOT_ACTIVE_VI) {
                            setAPIError('USER_NOT_ACTIVE');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === USER_EMPLOYER_EN || (response === null || response === void 0 ? void 0 : response.message) === USER_EMPLOYER_VI) {
                            setAPIError('USER_EMPLOYER');
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.message) === USER_BANNED_EN || (response === null || response === void 0 ? void 0 : response.message) === USER_BANNED_VI) {
                            setAPIError('USER_BANNED');
                        }
                        else {
                            setAPIError('WRONG_USER_PASS');
                        }
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        return [2 /*return*/];
                    }
                    tracking({
                        eventName: 'js_registration:login_success',
                        properties: {
                            isEmail: true,
                            isFacebook: false,
                            isGoogle: false,
                            isAppleid: false
                        }
                    });
                    setCookie(WS_TOKEN, encodeURIComponent(response.wsToken), 730);
                    setCookie(JS_TOKEN, encodeURIComponent(response.jsToken), 730);
                    setCookie(JS_ALL_TOKEN, encodeURIComponent(response.jsAllToken), 730);
                    setCookie(USER_COOKIE, encodeURIComponent(response.userCookie), 730);
                    setCookie(WS_COOKIE, encodeURIComponent(response.wsToken), 730);
                    letCheckReload = isNeedReload;
                    if (response.newRegistered) {
                        // Temporary disabled reload request when showing up onboarding
                        letCheckReload = false;
                    }
                    if (!letCheckReload) return [3 /*break*/, 3];
                    return [4 /*yield*/, delay(200)];
                case 2:
                    _a.sent();
                    window.location.reload();
                    return [2 /*return*/];
                case 3:
                    // Change password page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
                        window.location.href =
                            langCode === ELanguage.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    // Change email page
                    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
                        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
                        window.location.href =
                            langCode === ELanguage.VI
                                ? "https://".concat(getBaseUrl(), "/quan-ly-nghe-nghiep/tong-quan")
                                : "https://".concat(getBaseUrl(), "/my-career-center/dashboard");
                    }
                    _a.label = 4;
                case 4:
                    jsToken = decodeURIComponent(response.jsToken || '');
                    wsToken = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsToken, wsToken)
                        // Delay 100ms for cookie all done
                    ];
                case 5:
                    userInfo = _a.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        setIsLoginDisabled(false);
                        setIsLoggingIn(false);
                        if (!userInfo) {
                            setAPIError('WRONG_USER_PASS');
                            return;
                        }
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(UPDATE_USER, {
                            detail: {
                                user: userInfo,
                                isNewRegistered: response.newRegistered,
                                isApply: isApply
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                        if (typeof window !== 'undefined') {
                            try {
                                sendHogIdentify(window.posthog, userInfo, getBaseMsUrl());
                            }
                            catch (ex) {
                                console.error('postHog', ex);
                            }
                        }
                        setAPIError('NONE');
                        setMounted(false);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var inputKeyUp = function (e, type) {
        // turn off error message when keyUp
        if (type === 'email') {
            setUsernameError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
        }
        if (type === 'password') {
            setIsLoginDisabled(false);
            setPasswordError(false);
        }
        if (e.key === 'Enter') {
            setUsernameError(false);
            setAPIError('NONE');
            setPasswordError(false);
            doLogin();
        }
    };
    var getCSRFToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var csrfTokenResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Don't get csrf token again if it already exists
                    if (csrfToken !== null && csrfToken !== '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiGetCSRFToken()];
                case 1:
                    csrfTokenResponse = _a.sent();
                    setIsLoginDisabled(false);
                    if (csrfTokenResponse === null) {
                        return [2 /*return*/];
                    }
                    setCsrfToken((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.csrfToken) || '');
                    setJwtToken((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.jwtToken) || '');
                    setCookie(VNW_CSRF_JWT_TOKEN, encodeURIComponent((csrfTokenResponse === null || csrfTokenResponse === void 0 ? void 0 : csrfTokenResponse.jwtToken) || ''), 730);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderErrorMessage = function () {
        if (apiError === 'NONE') {
            return null;
        }
        if (apiError === 'USER_NOT_ACTIVE') {
            return (React__default.createElement(ErrorMessage, null, t('You have not verified your email. Please check your email inbox for instruction.')));
        }
        else if (apiError === 'USER_EMPLOYER') {
            return (React__default.createElement(ErrorMessage, null, t('This email address is registered as Employer, please Sign in from Employer Site.')));
        }
        else if (apiError === 'USER_BANNED') {
            return (React__default.createElement(ErrorMessage, null, t('The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.')));
        }
        return React__default.createElement(ErrorMessage, null, t('Wrong email or password. Please check again.'));
    };
    /**
     * Verify Auth Token and login in WebView (Mobile)
     */
    var getAuthTokenFromUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rawSearchParams, searchParamsPair, searchParams, filteredParams, authToken, response, jsToken, wsToken, userInfo;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (typeof window === 'undefined') {
                        return [2 /*return*/];
                    }
                    rawSearchParams = window.location.search.replace('?', '');
                    searchParamsPair = rawSearchParams.split('&');
                    searchParams = [];
                    searchParamsPair.map(function (item) {
                        var _a, _b, _c;
                        var query = item.split('=');
                        // Only check if query have a pair key value
                        if (query.length < 2) {
                            return;
                        }
                        searchParams.push({
                            key: (_b = (_a = query[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '',
                            value: (_c = query[1]) !== null && _c !== void 0 ? _c : ''
                        });
                    });
                    filteredParams = searchParams.filter(function (item) { return item.key === KEY_AUTH_TOKEN; });
                    if (filteredParams.length === 0) {
                        return [2 /*return*/];
                    }
                    authToken = (_b = (_a = filteredParams[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                    if (authToken === '') {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiVerifyAuthToken(authToken)
                        // handle response null error first
                    ];
                case 1:
                    response = _c.sent();
                    // handle response null error first
                    if (response === null) {
                        return [2 /*return*/];
                    }
                    setCookie(WS_TOKEN, encodeURIComponent(response.wsToken), 730);
                    setCookie(JS_TOKEN, encodeURIComponent(response.jsToken), 730);
                    setCookie(JS_ALL_TOKEN, encodeURIComponent(response.jsAllToken), 730);
                    setCookie(USER_COOKIE, encodeURIComponent(response.userCookie), 730);
                    setCookie(WS_COOKIE, encodeURIComponent(response.wsToken), 730);
                    jsToken = decodeURIComponent(response.jsToken || '');
                    wsToken = decodeURIComponent(response.wsToken || '');
                    return [4 /*yield*/, apiGetUserInfoFromToken(jsToken, wsToken)
                        // Delay 100ms for cookie all done
                    ];
                case 2:
                    userInfo = _c.sent();
                    // Delay 100ms for cookie all done
                    setTimeout(function () {
                        onLoggedInRef.current && onLoggedInRef.current(userInfo);
                        // get user and dispatch to AppShell user state
                        var updateUserEvent = new CustomEvent(UPDATE_USER, {
                            detail: {
                                user: userInfo
                            }
                        });
                        window.dispatchEvent(updateUserEvent);
                    }, 100);
                    return [2 /*return*/];
            }
        });
    }); };
    var buildSocialLink = function (socialName) {
        var socialLoginLink = getSocialLoginUrl(socialName, langCode, isApply, pageName);
        if (utmTracking !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(utmTracking));
        }
        if (socialUtm !== '') {
            socialLoginLink += encodeURIComponent("&=".concat(socialUtm));
        }
        return socialLoginLink;
    };
    useEffect(function () {
        window.addEventListener(LOGIN_POPUP, showLoginModal);
        window.showLoginModal = showLoginModal;
        // For mobile WebView
        getAuthTokenFromUrl();
        return function () {
            window.removeEventListener(LOGIN_POPUP, showLoginModal);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (!isMounted) {
            setUsernameError(false);
            setPasswordError(false);
            setAPIError('NONE');
            setIsLoginDisabled(false);
            return;
        }
        getCSRFToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMounted]);
    useEffect(function () {
        setLangCode(langCode === ELanguage.VI ? 'vi' : 'en');
    }, [langCode]);
    return (React__default.createElement(Popup, { isShow: isMounted, lang: modalLangCode === 'vi' ? ELanguage.VI : ELanguage.EN, text: {
            header: t('Sign in to continue'),
            primaryBtn: (React__default.createElement(React__default.Fragment, null,
                isLoggingIn ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(LoadingIcon, { bgColor: '#fff' }))) : null,
                ' ',
                t('Login')))
        }, option: {
            isCloseOnClickBackdrop: true,
            disabledPrimary: isLoginDisabled
        }, custom: {
            leftFooterAlert: (React__default.createElement(React__default.Fragment, null,
                t("Don't have an account yet?"),
                ' ',
                React__default.createElement(RegisterLink, __assign({ href: getRegisterUrl(modalLangCode === 'vi' ? ELanguage.VI : ELanguage.EN, utmTracking) }, (isRegisterOnNewTab
                    ? {
                        target: '_blank'
                    }
                    : null)), t('Register now'))))
        }, onClose: function () {
            setMounted(false);
            onCancelPopupRef.current && onCancelPopupRef.current();
        }, onClickPrimary: doLogin },
        React__default.createElement(LoginModalContainerWrapper, null,
            React__default.createElement(SocialLoginGroup, null,
                React__default.createElement(Button, { onClick: function () { return window.location.assign(buildSocialLink('google')); } },
                    React__default.createElement(GoogleLogoIcon, null),
                    " ",
                    !isMobile() ? React__default.createElement("span", null, t('with Google account')) : null),
                React__default.createElement(Button, { onClick: function () { return window.location.assign(buildSocialLink('facebook')); } },
                    React__default.createElement(FacebookLogoIcon, null),
                    " ",
                    !isMobile() ? React__default.createElement("span", null, t('with Facebook account')) : null)),
            React__default.createElement(SmallLabel, null, t('or with your email')),
            React__default.createElement(InputGroup, null,
                React__default.createElement(LabelInput, null,
                    t('Email'),
                    React__default.createElement("span", null, "*")),
                React__default.createElement(Input, { hasError: isUsernameError || apiError !== 'NONE', value: username, name: 'username', onChange: function (e) { return setUsername(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'email'); }, autoFocus: true, disabled: isLoggingIn }),
                isUsernameError ? (React__default.createElement(ErrorMessage, null, username.length === 0
                    ? t('The Email field is required.')
                    : t('The Email must be a valid Email address.'))) : null,
                renderErrorMessage()),
            React__default.createElement(InputGroup, null,
                React__default.createElement(LabelInput, null,
                    t('Password'),
                    React__default.createElement("span", null, "*")),
                React__default.createElement(Input, { hasError: isPasswordError, value: password, type: 'password', icon: 'password', onChange: function (e) { return setPassword(e); }, onKeyUp: function (e) { return inputKeyUp(e, 'password'); }, disabled: isLoggingIn }),
                isPasswordError ? React__default.createElement(ErrorMessage, null, t('The Password field is required.')) : null),
            React__default.createElement(ForgotGroup, null,
                React__default.createElement(ForgotPasswordLink, { href: getForgotPasswordUrl(modalLangCode === 'vi' ? ELanguage.VI : ELanguage.EN) }, t('Forgot Password?'))))));
};

export { LoginModal as default };
//# sourceMappingURL=index.js.map
